import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Button, Select } from "antd";
import { formatDateTime } from "../Customs/formatDateTime";
import { notify } from "../../customs/NotifyProvider";
import { AddonServices } from "../../Services/AddonServices";

const { TextArea } = Input;
const { Option } = Select;

const CreateDriver = ({ editorId, closeDrawer, getAddonServices }) => {
  const [form] = Form.useForm();
  const [id, setId] = useState(editorId);
  const [addonData, setAddonData] = useState([]);

  const isEdit = id !== undefined && id !== null;

  const getEditValues = async () => {
    try {
      const request = await AddonServices.DriverById(id);

      if (request?.status && request?.data) {
        setAddonData(request.data);
        form.setFieldsValue(request.data);
      } else {
        notify.error("Something went wrong", request?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isEdit) {
      getEditValues();
    }
  }, [id]);

  const handleFinish = async (values) => {
    const formData = {
      ...values,
      added_on: isEdit ? addonData?.added_on : formatDateTime(),
      updated_on: formatDateTime(),
    };

    let response;
    if (isEdit) {
      response = await AddonServices.updateDriver(id, formData);
    } else {
      response = await AddonServices.addDriver(formData);
    }

    if (response.status) {
      notify.success("Success", response.message);
      closeDrawer();
      setId(null);
      getAddonServices();
    } else {
      notify.error("Something went wrong!", response.message);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={{ status: "active" }}  // default value
    >
      {/* Driver Name */}
      <Form.Item
        name="driver_name"
        label="Driver Name"
        rules={[{ required: true, message: "Please enter driver name" }]}
      >
        <Input placeholder="Enter Driver Name" />
      </Form.Item>

      {/* Mobile Number */}
      <Form.Item
        name="mobile"
        label="Mobile Number"
        rules={[
          { required: true, message: "Please enter mobile number" },
          { len: 10, message: "Mobile number must be 10 digits" },
        ]}
      >
        <Input placeholder="Enter Mobile Number" maxLength={10} />
      </Form.Item>

      {/* License Number */}
      <Form.Item
        name="license_no"
        label="License Number"
        rules={[{ required: true, message: "Please enter license number" }]}
      >
        <Input placeholder="Enter License Number" />
      </Form.Item>

      {/* Experience */}
      <Form.Item name="experience" label="Experience (Years)">
        <InputNumber
          min={0}
          style={{ width: "100%" }}
          placeholder="Experience in years"
        />
      </Form.Item>

      {/* Address */}
      <Form.Item name="address" label="Address">
        <TextArea rows={3} placeholder="Enter Address" />
      </Form.Item>

      {/* Status */}
      <Form.Item
        name="status"
        label="Status"
        rules={[{ required: true, message: "Please select status" }]}
      >
        <Select placeholder="Select status">
          <Option value="active">Active</Option>
          <Option value="inactive">Inactive</Option>
        </Select>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save Driver
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CreateDriver;
